import axios from "axios";
import { API_URL } from "./client-config";
export default axios.create({
  baseURL: API_URL,
  // baseURL:"https://www.server.bamboo.rizq.no/"
  // baseURL:"http://192.168.100.8:3001/"
});
